import { toggleBooleanAttribute } from "../../assets/js/utilities/attributes";

//@ts-check
const tabBlocks = document.querySelectorAll('[data-tabs]');
if (tabBlocks.length) {
    tabBlocks.forEach(tabBlock => {
        const tabLinks = tabBlock.querySelectorAll('.tab-links .tab-link');
        const tabSections = tabBlock.querySelectorAll('.tab-content .tab-pane');

        tabLinks.forEach(tabLink => {
            tabLink.addEventListener('click', toggleTab);
        });

        function toggleTab(e) {
            e.preventDefault();

            const tabId = this.querySelector('a').getAttribute('href');
            const tabTarget = tabId.replace('#', '');

            // Check if the clicked tab is already active
            if (this.classList.contains('active')) {
                return;
            }

            tabLinks.forEach(tabLink => {
                if (tabLink.querySelector('a').getAttribute('href') !== tabId) {
                    tabLink.classList.remove('active');
                } else {
                    tabLink.classList.add('active');
                }
            });

            tabSections.forEach(tabSection => {
                if (tabSection.getAttribute('id') !== tabTarget) {
                    tabSection.classList.remove('active');
                } else {
                    tabSection.classList.add('active');
                }
            });
        }
    });
}

const tabAccordionBlocks = document.querySelectorAll( '[data-tabs-accordion]' );
if ( tabAccordionBlocks.length ) {
    tabAccordionBlocks.forEach( tabAccordionBlock => {
        const tabAccordionSections = tabAccordionBlock.querySelectorAll( '.tab-accordion-section' );
        tabAccordionSections.forEach( tabAccordionSection => {
            tabAccordionSection.addEventListener( 'click', toggleAccordion );
        } );

        function toggleAccordion( e ) {
            tabAccordionSections.forEach( tabAccordionSection => {
                const content = tabAccordionSection.querySelector( '.tab-accordion-content' );
                if ( tabAccordionSection !== e.currentTarget ) {
                    tabAccordionSection.classList.remove( 'open' );
                    content.setAttribute( 'aria-hidden', 'true' );
                } else {
                    tabAccordionSection.classList.toggle( 'open' );
                    toggleBooleanAttribute( 'aria-hidden', content );
                }
            } );
        }
    } );
}
